import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LaboratoryService } from '../../../laboratory.service';
import {
  ILaboratory,
  ILaboratoryUpdate,
  LABORATORY_TTL_ES
} from '../../../laboratory.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-laboratory-update',
  templateUrl: './laboratory-update.component.html'
})
export class LaboratoryUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  constructor(private fb: FormBuilder, private serviceBase: LaboratoryService) {
    super(LABORATORY_TTL_ES, serviceBase);
  }

  ngOnInit() {
    const item = this.row as ILaboratory;
    this.fg = this.fb.group({
      description: [
        item.description,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ]
    });
  }

  onSubmit() {
    this.updateItem$(this.fg.value as ILaboratoryUpdate);
  }
}
